import React from "react";
import { Dropdown } from "semantic-ui-react";
import { currencyOptions } from "src/utils/currencies";

export default function CurrencyOptions({ onChange, value, floating, basic, fluid, selection, button, disabled }) {
  return (
    <Dropdown
      selectOnBlur={false}
      className="cashflowCurrencyDropdown"
      placeholder="Moneda"
      fluid={fluid}
      selection={selection}
      onChange={(_, v) => onChange(v.value)}
      value={value}
      disabled={disabled}
      floating={floating}
      basic={basic}
      button={button}
      options={[
        ...currencyOptions,
        ...[{ key: "UF", value: "UF", flag: "cl", text: "UF" }],
        ...[{ key: "UTM", value: "UTM", flag: "cl", text: "UTM" }],
      ]}
    />
  );
}
